import { types } from '../types/types';

const initialState = {
    data:[],
    // data: [
    //       {
    //         id: new Date().getTime(),
    //         codigo: "7501055302451",
    //         costo: 22.00,
    //         desc: "COCA COLA 1 L.",
    //       },
    //       {
    //         id: new Date().getTime() + 2,
    //         codigo: "7501086801046",
    //         costo: 12.50,
    //         desc: "AGUA E-PURA 1L"
    //       },
    //       {
    //         id: new Date().getTime() + 3,
    //         codigo: "088381082020",
    //         costo: 1299.80,
    //         desc: "LIJADORA ORBITAL MAKITA BO4556"
    //       },
    //       {
    //         id: new Date().getTime() + 4,
    //         codigo: "079567520054",
    //         costo: 56.90,
    //         desc: "WD-40 MULTIUSOS"
    //       },
    //       {
    //         id: new Date().getTime() + 5,
    //         codigo: "7908371613733",
    //         costo: 299.90,
    //         desc: "CREMA HUMECTANTE TODODÍA"
    //       }
    //       ,
    //       {
    //         id: new Date().getTime() + 1,
    //         codigo: "7501563324310",
    //         costo: 1.30,
    //         desc: "DEXTROMETORFANO JARABE 15 MG / 5 ML"
    //       },
    //       {
    //         id: new Date().getTime() + 1,
    //         codigo: "7501125177637",
    //         costo: 22.60,
    //         desc: "ELECTROLIT PEDIÁTRICO 300 ml"
    //       },
    //       {
    //         id: new Date().getTime() + 1,
    //         codigo: "7501011104099",
    //         costo: 25.00,
    //         desc: "RUFLES QUESO 48 g."
    //       },
    //       {
    //         id: new Date().getTime() + 1,
    //         codigo: "7501011142299",
    //         costo: 17.00,
    //         desc: "CRUJITOS 48 g."
    //       },
    //       {
    //         id: new Date().getTime() + 1,
    //         codigo: "7501125116810",
    //         costo: 51.50,
    //         desc: "AGRIFEN ANTIGRIPAL."
    //       },
    //       {
    //         id: new Date().getTime() + 1,
    //         codigo: "7501349021570",
    //         costo: 120.00,
    //         desc: "AMOXICILINA 500 mg."
    //       },
    //       {
    //         id: new Date().getTime() + 1,
    //         codigo: "7501361682094",
    //         costo: 45.00,
    //         desc: "PARACETAMOL 500 mg"
    //       },
    //       {
    //         id: new Date().getTime() + 1,
    //         codigo: "7501299370018",
    //         costo: 37.90,
    //         desc: "NAPROXENO 250 mg."
    //       },
    //       {
    //         id: new Date().getTime() + 1,
    //         codigo: "7501206658680",
    //         costo: 37.90,
    //         desc: "ARMORALL BRILLO ORIGINAL 125 ML."
    //       },
    //       {
    //         id: new Date().getTime() + 1,
    //         codigo: "660731125344",
    //         costo: 259.90,
    //         desc: "RESPIRADOR DE MEDIA CARA SURTEK."
    //       },
    //       {
    //         id: new Date().getTime() + 1,
    //         codigo: "7501055303540",
    //         costo: 259.90,
    //         desc: "COCA COLA 1,5 L."
    //       },
    //       {
    //         id: new Date().getTime() + 1,
    //         codigo: "7506192503358",
    //         costo: 34.90,
    //         desc: "GEL EGO 200 ml."
    //       },
    //       {
    //         id: new Date().getTime() + 1,
    //         codigo: "039564145414",
    //         costo: 249.90,
    //         desc: "SET DE DESTORNILLADORES DE PRECISIÓN 34 PZ."
    //       },
    //       {
    //         id: new Date().getTime() + 1,
    //         codigo: "7503028126712",
    //         costo: 560,
    //         desc: "DISCO DURO SÓLIDO STYLOS 480 GB."
    //       },

    // ],
    carritoItems: JSON.parse(localStorage.getItem('items')) || [],
   
}

export const carritoReducer = ( state = initialState, action ) => {
  
    switch (action.type) {

      case types.carritoGetLoaded:
        return {
                ...state,
                data: [ ...action.payload ]
            }

        case types.carritoAddItem:
            
            return {
                ...state,
                carritoItems: [
                    ...state.carritoItems,
                    action.payload
                ]
            }

        case types.carritoDeleteItemGetLoaded:

            return {
                ...state,
                carritoItems: [ ...action.payload ]
            }

        
    
        default:
            return state
    }

}
